// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2etfv","questions":"styles_questions__18fjf","footer":"styles_footer__3jUhM"};